const axios = require("axios");
/* NodeJS */
const url = process.env.REACT_APP_BASE_FINGI_CORE_BASE_URL;
const urlV5 = url.replace("v1", "v5");

module.exports = {
  postReddotPayment: (accessToken, cardData) =>
    axios({
      method: "POST",
      url: `${url}/payments`,
      headers: { Authorization: `Bearer ${accessToken}` },
      data: cardData,
    }),
  getServiceToken: (accessToken, nodeId) =>
    axios({
      method: "GET",
      url: `${urlV5}/payments/service_token?node_id=${nodeId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }),
  postCeloPayment: (accessToken, cardData) =>
    axios({
      method: "POST",
      url: `${urlV5}/payments/celo_payment`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: cardData,
    }),
  postCeloTokinze: (baseUrl, accessToken, data) =>
    axios({
      method: "POST",
      url: `${baseUrl}/v1/sentry/token`,
      headers: {
        Authorization: accessToken,
        "content-type": "application/json",
      },
      data,
    }),
  postWindcaveLink: (accessToken, data) =>
    axios({
      method: "POST",
      url: `${urlV5}/payments/windcave_payment_link`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "content-type": "application/json",
      },
      data,
    }),
  getWindcaveLinkStatus: (accessToken, jobId, email) =>
    axios({
      method: "GET",
      url: `${urlV5}/payments/windcave_payment_link_status?job_id=${jobId}&booking[email]=${encodeURIComponent(
        email
      )}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "content-type": "application/json",
      },
    }),
  postWindcaveTransaction: (accessToken, data) =>
    axios({
      method: "POST",
      url: `${urlV5}/payments/windcave_transaction`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "content-type": "application/json",
      },
      data,
    }),
  getWindcaveTransactionStatus: (accessToken, jobId, email) =>
    axios({
      method: "GET",
      url: `${urlV5}/payments/windcave_transaction_status?job_id=${jobId}&booking[email]=${encodeURIComponent(
        email
      )}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "content-type": "application/json",
      },
    }),
  postGlobalBlueLink: (accessToken, data) =>
    axios({
      method: "POST",
      url: `${urlV5}/payments/global_blue_payment_link`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "content-type": "application/json",
      },
      data,
    }),
  getGlobalBlueLinkStatus: (accessToken, jobId, email) =>
    axios({
      method: "GET",
      url: `${urlV5}/payments/global_blue_payment_link_status?job_id=${jobId}&booking[email]=${encodeURIComponent(
        email
      )}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "content-type": "application/json",
      },
    }),
  postGlobalBlueTransaction: (accessToken, data) =>
    axios({
      method: "POST",
      url: `${urlV5}/payments/global_blue_transaction`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "content-type": "application/json",
      },
      data,
    }),
  getGlobalBlueTransactionStatus: (accessToken, jobId, email) =>
    axios({
      method: "GET",
      url: `${urlV5}/payments/global_blue_transaction_status?job_id=${jobId}&booking[email]=${encodeURIComponent(
        email
      )}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "content-type": "application/json",
      },
    }),

  postHotelKeyPaymentLink: (accessToken, data) =>
    axios({
      method: "POST",
      url: `${urlV5}/payments/hotelkey_payment_link`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "content-type": "application/json",
      },
      data,
    }),
  getHotelKeyPaymentLinkStatus: (accessToken, jobId, email) =>
    axios({
      method: "GET",
      url: `${urlV5}/payments/hotelkey_payment_link_status?job_id=${jobId}&booking[email]=${encodeURIComponent(
        email
      )}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "content-type": "application/json",
      },
    }),
  getHotelKeyPaymentTransactionStatus: (
    accessToken,
    paymentTransaction,
    reservationId,
    email,
    type,
    uid
  ) =>
    axios({
      method: "GET",
      url:
        `${url}/payment_transactions/hotelkey_transaction_status?` +
        `type=${type}&` +
        `uid=${uid}&` +
        `reference=${paymentTransaction}&` +
        `reservation_id=${reservationId}&` +
        `booking[email]=${encodeURIComponent(email)}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "content-type": "application/json",
      },
    }),
};
